// LEGACY UI: replace with Field with Input and FieldError from @workspace/frontend-ui.
// Don't import this in new code; legacy-ui.json tracks the remaining importers
// and only shrinks (scripts/legacy-ui-check.mjs).
import useTranslation from "@casino/legacy/client/hooks/i18n/useTranslation";
import FormError from "@casino/legacyUi/form/FormError";
import { Field } from "@workspace/frontend-ui";
import { forwardRef } from "react";
import TextInput from "./TextInput";
import type { TextInputProps } from "./TextInput/types";

type Props = TextInputProps & {
  error?: string;
  isSharpTopSide?: boolean;
  skipErrorMessage?: boolean;
  isErrorTop?: boolean;
  isSharpBottomSide?: boolean;
  inputSize?: string;
};

const FormInput = forwardRef<HTMLInputElement, Props>((props, ref) => {
  const {
    error = "",
    label = "" as string,
    placeholder = "",
    type = "",
    name = "",
    isErrorTop = false,
    skipErrorMessage,
    ...inputProps
  } = props;

  const labelTranslation = useTranslation(label as string);
  const placeholderTranslation = useTranslation(placeholder);
  const skipError = skipErrorMessage || !error;

  return (
    <Field>
      {!skipError && isErrorTop && (
        <FormError message={error} data-testid={`${name}-form-error`} />
      )}
      <TextInput
        label={labelTranslation}
        ref={ref}
        type={type}
        isError={!!error}
        placeholder={placeholderTranslation}
        name={name}
        {...inputProps}
      />
      {!skipError && !isErrorTop && (
        <FormError
          message={error}
          data-testid={`${name}-form-error`}
          className="mt-0"
        />
      )}
    </Field>
  );
});

export default FormInput;
